import { Divider } from "components/atoms/Divider";
import { StepperProps } from "components/organisms/Stepper";
import Omit from "lodash/omit";
import { zIndex } from "shared/styles";
import { css } from "styled-components";
import tw from "twin.macro";
/**
 * @param steps [Step[]]
 * @param currentStep [number]
 * @param className [string]
 * @returns JSX.Element
 */
export const HorizontalStepper = ({
  steps,
  currentStep,
  className,
}: Omit<StepperProps, "vertical">) => {
  return (
    <div tw="relative flex-center flex-col" className={className}>
      <div tw="flex w-full" css={css({ zIndex: zIndex.priority })}>
        {steps?.map((step, index) => {
          const isActive = currentStep === index + 1;
          return (
            <div key={index} tw="flex-1 flex flex-col items-center">
              <div tw="flex-1 flex-center flex-col">
                {step.iconLabel && (
                  <span tw="font-semibold text-[8px] text-theme mb-2">
                    {step.iconLabel}
                  </span>
                )}
                <div
                  tw="bg-blossom w-7 h-7 rounded-full flex-center"
                  css={isActive && tw`bg-gradient-theme-to-l`}
                >
                  {step.icon ? (
                    step.icon
                  ) : (
                    <span
                      tw="font-semibold text-sm leading-[14px] text-theme"
                      css={isActive && tw`text-white`}
                    >
                      {index + 1}
                    </span>
                  )}
                </div>
              </div>
              {(step.title || step.description) && (
                <div>
                  {step.title && (
                    <h4 tw="font-base text-sm leading-[14px] tracking-[.4px]">
                      {step.title}
                    </h4>
                  )}
                  {step.description && (
                    <p tw="font-normal text-2xs leading-4 text-black mt-1">
                      {step.description}
                    </p>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
      <Divider tw="bg-blossom absolute top-8 w-3/4 mx-auto" />
    </div>
  );
};
